import React from 'react';
import OnboardingSection from '../OnboardingSection';

type OnboardingAvailabilityProps = {
  onEdit: () => void;
};

/**
 * Renders an OnboardingAvailability button
 * @example
 *
 * const MyComponent = () => {
 *   return (
 *     <OnboardingAvailability onEdit={handleEdit} />
 *   );
 * }
 */
const OnboardingAvailability: React.FCWithChildren<OnboardingAvailabilityProps> = ({
  onEdit,
}) => (
  <OnboardingSection
    onClick={onEdit}
    label="Add your availability"
    testID="onboardingAddAvailability"
  />
);

export default OnboardingAvailability;
